import { CPPElements } from 'rcd-cpp-docs';
import * as React from 'react';
import URLManager from '../../utils/urlManager';

export type ToasterWithLinkWrapper = ToasterWrapper<TWLProps>;

type ToasterWrapper<P> = {
  id: string;
  toaster: CPPElements.Toaster;
  show: (props: P | string, loading?: boolean) => void;
  hide: () => void;
  error: (props: P | string) => void;
  warn: (props: P | string) => void;
  success: (props: P | string) => void;
};

type Opts = {
  updateUrl?: URLManager.UpdateURLFn;
};

export type Toasters<P> = {
  createToaster: () => ToasterWrapper<P>;
  hideToasters: (group?: string) => void;
};
export const useToaster = <P,>(
  T?: ToasterNode<P>,
  opts: Opts = {}
): Toasters<P> => {
  const toasters = document.getElementById(
    'cppToasters'
  ) as CPPElements.Toasters;

  if (!toasters?.getToasters) {
    console.error('Toasters not found');
    return { hideToasters: () => null, createToaster: () => null };
  }

  const hideToasters = (group?: string) => {
    if (!group) {
      toasters.getToasters().forEach(t => t.hide());
    } else {
      toasters.getToastersByGroup(group).forEach(t => t.hide());
    }
  };
  const getContent = (p: string | any, loading?: boolean) => {
    if (!T || typeof p == 'string') return { component: p, loading };
    return { component: <T {...opts} {...p} />, loading };
  };
  return {
    hideToasters,
    createToaster: (): ToasterWrapper<P> => {
      const toaster = toasters.createToaster();
      return {
        id: toaster.id,
        toaster,
        hide: () => {
          toaster.hide();
        },
        show: (props, loading) => {
          toaster.show(getContent(props, loading));
        },
        warn: props => {
          toaster.warn(getContent(props));
        },
        error: props => {
          toaster.error(getContent(props));
        },
        success: props => {
          toaster.success(getContent(props));
        }
      };
    }
  };
};

type ToasterNode<P> = React.FC<P>;

type TWLProps = {
  header?: string;
  messages: (
    | string
    | { url: string; text: string; params?: URLManager.Params }
  )[];
};
export const ToasterWithLink: ToasterNode<TWLProps> = ({
  header,
  messages,
  updateUrl
}: TWLProps & Opts) => {
  return (
    <div>
      {header && (
        <div>
          <b>{header}</b>
        </div>
      )}
      <div>
        {messages &&
          messages.map((m, i) => {
            if (typeof m == 'string') return m;
            return (
              <a
                key={i}
                href={m.url}
                onClick={e => {
                  if (m.params) {
                    updateUrl(m.params);
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  }
                }}
              >
                {m.text}
              </a>
            );
          })}
      </div>
    </div>
  );
};
